import React from 'react';

import PayrollCompanySettings from '../PayrollCompanySettings';

// Lön & semester — lifted out of Bokföring, where it had no business being:
// payroll company settings are not bokföringsinställningar. Its own route
// under Försäljning & lön since the IA split.
const PayrollSection = () => (
  <div id="lon">
    <PayrollCompanySettings />
  </div>
);

export default PayrollSection;
